import { makeStyles } from '@material-ui/core';
var paginationStyles = makeStyles(function (theme) { return ({
    container: {
        marginLeft: '1%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    select: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}); });
export default paginationStyles;
//# sourceMappingURL=styles.js.map